'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.RestService
 * @description
 * # RestService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('RestService', function($http, $q) {
  function processPaginationPages(result) {
    if (result.pages.pagination) {
      var last = result.pages.pagination.last ? result.pages.pagination.last : (result.pages.pagination.prev  ? result.pages.pagination.prev+1 : 0);
      for (var i = 1; i <= last; i++) {
        result.pages.numbers.push(i);
      }
    }
  }

  return {
    getFromUrl: function(url, params) {
      var deferred = $q.defer();
      var _this = this;

      if (!url) {
        deferred.reject();
      }

      $http.get(url, {params: params}).catch(deferred.reject).then(function(result) {
        result = {
          data: result.data,
          pages: {
            numbers: [],
            pagination: _this.getHeaderPages(result.headers)
          }
        };
        processPaginationPages(result);
        deferred.resolve(result);
      });

      return deferred.promise;
    },

    postToUrl: function(url, config) {
      var _this = this;

      var data = config.data;
      delete config.data;

      return $http.post(url, data, config).then(function(result) {
        result = {
          data: result.data,
          pages: {
            numbers: [],
            pagination: _this.getHeaderPages(result.headers)
          }
        };
        processPaginationPages(result);
        return result;
      });
    },

    getHeaderPages: function(headers) {
      var valueHeaders = headers ? headers('Link') : null;
      if (!valueHeaders) {
        return null;
      }

      var parts = valueHeaders.split(',');
      var links = {};

      for (var i = 0; i <= parts.length-1; i++) {
        var section = parts[i].split(';');
        if (section.length !== 2) {
          return null;
        }

        var url = section[0].replace(/<(.*)>/, '$1').trim();
        var queryString = {};
        url.replace(
          new RegExp("([^?=&]+)(=([^&]*))?", "g"),
          function(_$0, $1, _$2, $3) {
            queryString[$1] = $3;
          }
        );
        var page = parseInt(queryString.page);
        var name = section[1].replace(/rel="(.*)"/, '$1').trim();
        links[name] = page;
      }

      return links;
    }
  };
});
